<template>
  <div class="home" v-if="data.length > 0">
    <div class="top">
      <div class="top-left">
        <div class="top-left-text" v-html="data[0].content"></div>
      </div>
      <div class="top-right">
        <img class="image" :src="data[0].photo[0]" alt="">
      </div>
      <div class="top-v" v-if="hotageData.length > 0" @click="edit(hotageData[0].id)">
        <div class="top-v-text">{{ hotageData[0].category_name }}演员</div>
        <img class="top-v-img" src="@/assets/img/yiren/arrow-right.png" alt="">
      </div>
      <div class="top-v" style="top: 251px;right: -136px;" v-if="hotageData.length > 1" @click="edit(hotageData[1].id)">
        <div class="top-v-text">{{ hotageData[1].category_name }}演员</div>
        <img class="top-v-img" src="@/assets/img/yiren/arrow-right.png" alt="">
      </div>
      <div class="top-v" style="top: 370px;" v-if="hotageData.length >= 2" @click="edit(hotageData[2].id)">
        <div class="top-v-text">{{ hotageData[2].category_name }}演员</div>
        <img class="top-v-img" src="@/assets/img/yiren/arrow-right.png" alt="">
      </div>
    </div>
    <div class="top-rights">
      <img class="top-rights-f" :src="data[1].photo[0]" alt="">
      <img class="top-rights-s" :src="data[1].photo[1]" alt="">
      <div class="top-rights-t" v-html="data[1].content"></div>
    </div>
    <div class="top-title">
      <div class="title">
        <div class="title-t">{{ data[2].title }}</div>
        <div class="title-b" v-html="data[2].content"></div>
      </div>
      <div class="title-img">
        <img class="top-title-t" :src="data[2].photo[0]" alt="">
        <img class="top-title-s" :src="data[2].photo[1]" alt="">
      </div>
      <div class="title-s">
        <div class="title-t">{{ data[3].title }}</div>
        <div class="title-b" style="margin-top: 74px;" v-html="data[3].content"></div>
      </div>
      <img class="bottom-img" :src="data[3].photo[0]" alt="">
    </div>
    <div class="film">
      <img class="film-top-img" :src="data[3].photo[1]" alt="">
      <img class="film-top-imgs" :src="data[4].photo[0]" alt="">
      <img class="film-top-imgss" :src="data[4].photo[1]" alt="">
      <div class="film-text" v-html="data[4].content"></div>
    </div>
    <div class="portrait">
      <div class="top-left">
        <div class="top-left-text" v-html="data[5].content"></div>
      </div>
      <img class="portrait-right" :src="data[5].photo[0]" alt="">
      <img class="portrait-rights" :src="data[5].photo[1]" alt="">
    </div>
    <div class="artist">
      <img class="artist-img" :src="data[6].photo[0]" alt="">
      <div class="artist-text" v-html="data[6].content"></div>
    </div>
    <div class="eight">
      <img class="eight-img" :src="data[7].photo[0]" alt="">
      <img class="eight-imgs" :src="data[7].photo[1]" alt="">
      <div class="title">
        <div class="title-t">{{ data[7].title }}</div>
        <div class="title-b" v-html="data[7].content"></div>
      </div>
    </div>
    <div class="nine">
      <div class="top-left">
        <div class="top-left-text" v-html="data[8].content">
        </div>
      </div>
      <img class="nine-img" :src="data[8].photo[0]" alt="">
      <img class="nine-imgs" :src="data[8].photo[1]" alt="">
    </div>
    <div class="ten">
      <img class="ten-img" :src="data[9].photo[0]" alt="">
      <img class="ten-imgs" :src="data[9].photo[1]" alt="">
      <div class="title-s">
        <div class="title-t">{{ data[9].title }}</div>
        <div class="title-b" style="margin-top: 74px;" v-html="data[9].content"></div>
      </div>
    </div>
    <div class="content">
      <div class="title-t">{{ data[10].title }}</div>
      <div class="title-b" style="margin-top: 74px;" v-html="data[10].content"></div>
    </div>
    <div class="banner w">
      <img class="banner-img" :src="data[10].photo[0]" alt="">
      <img class="banner-img" :src="data[10].photo[1]" alt="">
      <img class="banner-img" :src="data[10].photo[2]" alt="">
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import appimg from "../assets/img/allThings/app.png"
import { mapGetters, mapActions } from 'vuex'
export default {
  name: "HelloWorld",
  components: {
    appimg,
  },
  data() {
    return {
      data: [],
      hotageData: []
    };
  },
  created() { },
  computed: {},
  mounted() {
    this.getList()
    this.getHotage()
  },
  beforeDestroy() {
  },
  methods: {
    ...mapActions([
      'setSaveHigh'
    ]),
    getList() {
      this.$http.get('/api/index/gethomeinfo')
        .then(res => {
          if (res.status == 200) {
            this.data = res.data.data
          } else {
            this.$message({
              message: res.msg,
              type: "error"
            });
          }
        })
    },
    getHotage() {
      this.$http.get('/api/index/gethotagelist')
        .then(res => {
          if (res.status == 200) {
            this.hotageData = res.data.data
          } else {
            this.$message({
              message: res.msg,
              type: "error"
            });
          }
        })
    },
    // 跳转艺人库查看更多
    edit(e) {
      this.setSaveHigh('AboutUs')
      this.$router.push({ name: 'AboutUs', query: { id: e } })
    },
  }
};
</script>

<style lang="scss" scoped>
.home {
  .top {
    margin-top: 144px;
    width: 1210px;
    border-radius: 0px 600px 600px 0px;
    background-color: #ECECEC;
    padding: 115px 0 115px 315px;
    font-size: 15px;
    position: relative;
    margin-bottom: 296px;

    .top-left {
      width: 400px;
      font-family: PingFang SC, PingFang SC;
      font-weight: 400;
      font-size: 15px;
      color: #292929;
      line-height: 28px;
      text-align: left;
      font-style: normal;
      text-transform: none;

      .top-left-text {
        margin-bottom: 20px;
      }
    }

    .top-right {
      position: absolute;
      top: -110px;
      right: 200px;

      .image {
        width: 573px;
      }
    }

    .top-v {
      position: absolute;
      top: 132px;
      right: -90px;
      display: flex;
      align-items: center;
      background: #000000;
      padding: 19px 72px;
      border-radius: 50px 0px 50px 0px;
      cursor: pointer;

      .top-v-text {
        font-size: 20px;
        color: #ffffff;
        margin-right: 6px;
      }

      .top-v-img {
        width: 24px;
      }
    }
  }

  .top-rights {
    width: 1678px;
    height: 700px;
    background-color: #F5F5F5;
    color: #292929;
    font-size: 15px;
    margin-bottom: 364px;
    margin-left: auto;
    position: relative;

    .top-rights-f {
      width: 400px;
      height: 586px;
      position: absolute;
      top: 315px;
      left: 68px;
    }

    .top-rights-s {
      width: 300px;
      height: 431px;
      position: absolute;
      top: 101px;
      left: 539px;
    }

    .top-rights-t {
      width: 409px;
      position: absolute;
      top: 185px;
      right: 302px;
    }
  }

  .top-title {
    height: 1854px;
    position: relative;

    .title {
      width: 596px;
      color: #292929;
      position: absolute;
      top: 559px;
      left: 310px;

      .title-t {
        font-family: PingFang SC, PingFang SC;
        font-weight: 600;
        font-size: 30px;
        line-height: 40px;
        text-align: left;
        font-style: normal;
        text-transform: none;
      }

      .title-b {
        font-size: 15px;
        margin-top: 40px;
      }
    }

    .title-s {
      position: absolute;
      bottom: 250px;
      right: 310px;
      width: 600px;

      .title-t {
        font-family: PingFang SC, PingFang SC;
        font-weight: 600;
        font-size: 30px;
        line-height: 40px;
        text-align: center;
        font-style: normal;
        text-transform: none;
      }

      .title-b {
        font-size: 15px;
        margin-top: 40px;
      }
    }

    .title-img {
      position: absolute;
      top: 364px;
      right: 510px;

      .top-title-t {
        width: 390px;
        height: 589px;
        position: relative;

      }

      .top-title-s {
        position: absolute;
        top: 181px;
        right: -262px;
        z-index: 999;
        width: 328px;
        height: 456px;
      }
    }

    .bottom-img {
      width: 612px;
      height: 859px;
      position: absolute;
      left: 242px;
      bottom: -100px;
      z-index: 999;
    }
  }

  .film {
    height: 1513px;
    background: linear-gradient(#EEEEEE, #FFFFFF);
    position: relative;

    .film-top-img {
      width: 583px;
      height: 757px;
      position: absolute;
      top: -188px;
      right: 241px;
    }

    .film-top-imgs {
      width: 280px;
      height: 412px;
      position: absolute;
      bottom: 310px;
      left: 307px;
    }

    .film-top-imgss {
      width: 280px;
      height: 412px;
      position: absolute;
      bottom: 200px;
      left: 615px;
    }

    .film-text {
      width: 537px;
      font-size: 15px;
      position: absolute;
      bottom: 361px;
      right: 310px;
    }
  }

  .portrait {
    height: 700px;
    background: linear-gradient(to right, #EEEEEE, #FFFFFF);
    position: relative;
    margin-bottom: 363px;

    .top-left {
      position: absolute;
      left: 312px;
      top: 185px;
      width: 400px;
      font-family: PingFang SC, PingFang SC;
      font-weight: 400;
      font-size: 15px;
      color: #292929;
      line-height: 28px;
      text-align: left;
      font-style: normal;
      text-transform: none;

      .top-left-text {
        margin-bottom: 20px;
      }
    }

    .portrait-right {
      width: 300px;
      height: 400px;
      position: absolute;
      top: 90px;
      right: 707px;
    }

    .portrait-rights {
      width: 400px;
      height: 533px;
      position: absolute;
      bottom: -110px;
      right: 242px;
      z-index: 999;
    }
  }

  .artist {
    display: flex;
    align-items: center;

    .artist-img {
      width: 1141px;
      height: 533px;
      margin-right: 113px;
    }

    .artist-text {
      width: 349px;
      font-size: 15px;
      color: #292929;
    }
  }

  .eight {
    height: 837px;
    position: relative;

    .eight-img {
      width: 390px;
      height: 589px;
      position: absolute;
      top: 200px;
      left: 310px;
    }

    .eight-imgs {
      width: 328px;
      height: 456px;
      position: absolute;
      top: 381px;
      left: 572px;
    }

    .title {
      width: 596px;
      color: #292929;
      position: absolute;
      top: 432px;
      right: 310px;

      .title-t {
        font-family: PingFang SC, PingFang SC;
        font-weight: 600;
        font-size: 30px;
        line-height: 40px;
        text-align: left;
        font-style: normal;
        text-transform: none;
      }

      .title-b {
        font-size: 15px;
        margin-top: 40px;
      }
    }
  }

  .nine {
    height: 1133px;
    position: relative;

    .top-left {
      position: absolute;
      left: 310px;
      top: 376px;
      width: 400px;
      font-family: PingFang SC, PingFang SC;
      font-weight: 400;
      font-size: 15px;
      color: #292929;
      line-height: 28px;
      text-align: left;
      font-style: normal;
      text-transform: none;

      .top-left-text {
        margin-bottom: 20px;
      }
    }

    .nine-img {
      width: 400px;
      height: 586px;
      position: absolute;
      top: 297px;
      right: 560px;
    }

    .nine-imgs {
      width: 300px;
      height: 431px;
      position: absolute;
      top: 200px;
      right: 242px;
    }
  }

  .ten {
    height: 1354px;
    position: relative;

    .ten-img {
      width: 612px;
      height: 859px;
      position: absolute;
      top: 250px;
      left: 242px;
    }

    .ten-imgs {
      width: 483px;
      height: 757px;
      position: absolute;
      bottom: 0px;
      right: 242px;
    }

    .title-s {
      position: absolute;
      top: 268px;
      right: 310px;
      width: 600px;

      .title-t {
        font-family: PingFang SC, PingFang SC;
        font-weight: 600;
        font-size: 30px;
        line-height: 40px;
        text-align: center;
        font-style: normal;
        text-transform: none;
      }

      .title-b {
        font-size: 15px;
        margin-top: 40px;
      }
    }
  }

  .content {
    margin: 200px auto 0;
    width: 600px;

    .title-t {
      font-family: PingFang SC, PingFang SC;
      font-weight: 600;
      font-size: 30px;
      line-height: 40px;
      text-align: center;
      font-style: normal;
      text-transform: none;
    }

    .title-b {
      font-size: 15px;
      margin-top: 40px;
    }
  }

  .banner {
    padding: 77px 0 197px 0;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .banner-img {
      width: 401px;
      height: 631px;
    }
  }

}
</style>
